export const ServerURL = {
    PRODUCTION_HOST_URL: `https://tennavi-api.azurewebsites.net/`,   
    WEBSOCKET_HOST_URL: `tennavi-api.azurewebsites.net`  
};

export default ServerURL;
